import { kuferClient } from '@xver/libs/axios';

import {
    AuthorizationResponse,
    GetAuthorizeResponse,
    GetDockerfileQueryModel,
    GetDockerfileResponse,
    ListRepositoriesQueryModel,
    ListRepositoriesResponse,
} from './model';

const ENDPOINTS = {
    AUTHORIZE: '/v1/github/authorize',
    CALLBACK: '/v1/github/callback',
    AUTHORIZATIONS: '/v1/github/authorizations',
    DELETE_AUTHORIZATION: (id: string) => `/v1/github/authorizations/${id}`,
    REPOSITORIES: '/v1/github/repositories',
    DOCKERFILE: (owner: string, repository: string) =>
        `/v1/github/repositories/${owner}/${repository}/dockerfile`,
};

export function getAuthorizeUrl(): Promise<GetAuthorizeResponse> {
    return kuferClient.get(ENDPOINTS.AUTHORIZE);
}

export function completeCallback(code: string, state: string): Promise<AuthorizationResponse> {
    return kuferClient.get(ENDPOINTS.CALLBACK, { params: { code, state } });
}

export function getAuthorization(): Promise<AuthorizationResponse> {
    return kuferClient.get(ENDPOINTS.AUTHORIZATIONS);
}

export function deleteAuthorization(id: string): Promise<void> {
    return kuferClient.delete(ENDPOINTS.DELETE_AUTHORIZATION(id));
}

export function listRepositories(
    params?: ListRepositoriesQueryModel
): Promise<ListRepositoriesResponse> {
    return kuferClient.get(ENDPOINTS.REPOSITORIES, { params });
}

export function getDockerfile(
    owner: string,
    repository: string,
    params?: GetDockerfileQueryModel
): Promise<GetDockerfileResponse> {
    return kuferClient.get(ENDPOINTS.DOCKERFILE(owner, repository), { params });
}
